import { render, staticRenderFns } from "./novel-ad-unlock-config.vue?vue&type=template&id=98e09288"
import script from "./novel-ad-unlock-config.vue?vue&type=script&lang=js"
export * from "./novel-ad-unlock-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports